export async function fetchPhotoGallery() {
    try {
    //   const response = await fetch(`https://your-api-url/characters/${label}`);
    //   const data = await response.json();
      return photoGalleryData;
    } catch (error) {
      console.error("Failed to fetch character data:", error);
    }
}

const photoGalleryData = [
  {
    "genus": "Abaristophora",
    "tags": [],
    "images": [
      "https://phorid.net/uploads_genera/Abaristophora-lateral.jpg"
    ]
  },
  {
    "genus": "Acanthophorides",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Acanthophorides-lateral.jpg"
    ]
  },
  {
    "genus": "Achaetophora",
    "tags": [],
    "images": [
    ]
  },
  {
    "genus": "Acontistoptera",
    "tags": ["brachypterous"],
    "images": [
      "https://phorid.net/uploads_genera/Acontistoptera-lateral.jpg"
    ]
  },
  {
    "genus": "Adelopteromyia",
    "tags": [],
    "images": [
      "https://phorid.net/uploads_genera/Adelopteromyia-lateral.jpg"
    ]
  },
  {
    "genus": "Adenophora",
    "tags": ["apterous"],
    "images": [
      "https://phorid.net/uploads_genera/Adenophora-lateral.jpg"
    ]
  },
  {
    "genus": "Aemulophora",
    "tags": ["brachypterous"],
    "images": [
      "https://phorid.net/uploads_genera/Aemulophora-lateral.jpg"
    ]
  },
  {
    "genus": "Aenictacantha",
    "images": [
    ]
  },
  {
    "genus": "Aenictomyia",
    "images": [
    ]
  },
  {
    "genus": "Aenigmaphora",
    "images": [
    ]
  },
  {
    "genus": "Aenigmatias",
    "tags": ["apterous"],
    "images": [
      "https://phorid.net/uploads_genera/Aenigmatias-lateral.jpg"
    ]
  },
  {
    "genus": "Aenigmatistes",
    "images": [
    ]
  },
  {
    "genus": "Aenigmatopoeus",
    "images": [
    ]
  },
  {
    "genus": "Allochaeta",
    "images": [
      "https://phorid.net/uploads_genera/Allochaeta-lateral.jpg"
    ]
  },
  {
    "genus": "Anevrina",
    "images": [
      "https://phorid.net/uploads_genera/Anevrina-lateral.jpg"
    ]
  },
  {
    "genus": "Anticofimbria",
    "images": [
    ]
  },
  {
    "genus": "Aphiura",
    "images": [
    ]
  },
  {
    "genus": "Apocephalus",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Apocephalus-lateral.jpg"
    ]
  },
  {
    "genus": "Apodicrania",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Apodicrania-lateral.jpg"
    ]
  },
  {
    "genus": "Apterella",
    "tags": ["apterous"],
    "images": [
      "https://phorid.net/uploads_genera/Apterella-lateral.jpg"
    ]
  },
  {
    "genus": "Apterophora",
    "images": [
      "https://phorid.net/uploads_genera/Apterophora-lateral.jpg"
    ]
  },
  {
    "genus": "Aptinandria",
    "images": [
    ]
  },
  {
    "genus": "Arabiphora",
    "images": [
    ]
  },
  {
    "genus": "Archiphora",
    "images": [
      "https://phorid.net/uploads_genera/Archiphora-lateral.jpg"
    ]
  },
  {
    "genus": "Aristocerina",
    "images": [
    ]
  },
  {
    "genus": "Arrenaptenus",
    "images": [
    ]
  },
  {
    "genus": "Assmutherium",
    "images": [
    ]
  },
  {
    "genus": "Auxanommatidia",
    "images": [
      "https://phorid.net/uploads_genera/Auxanommatidia-lateral.jpg"
    ]
  },
  {
    "genus": "Beckerina",
    "images": [
      "https://phorid.net/uploads_genera/Beckerina-lateral.jpg"
    ]
  },
  {
    "genus": "Beyermyia",
    "images": [
    ]
  },
  {
    "genus": "Billotia",
    "images": [
    ]
  },
  {
    "genus": "Bolsiusia",
    "images": [
    ]
  },
  {
    "genus": "Borgmeieriphora",
    "images": [
      "https://phorid.net/uploads_genera/Borgmeieriphora-lateral.jpg"
    ]
  },
  {
    "genus": "Borophaga",
    "images": [
      "https://phorid.net/uploads_genera/Borophaga-lateral.jpg"
    ]
  },
  {
    "genus": "Bothroprosopa",
    "images": [
    ]
  },
  {
    "genus": "Brachycephaloptera",
    "images": [
      "https://phorid.net/uploads_genera/Brachycephaloptera-lateral.jpg"
    ]
  },
  {
    "genus": "Brachycosta",
    "images": [
    ]
  },
  {
    "genus": "Brachyphlebina",
    "images": [
    ]
  },
  {
    "genus": "Brachyselia",
    "images": [
    ]
  },
  {
    "genus": "Brownphora",
    "images": [
      "https://phorid.net/uploads_genera/Brownphora-lateral.jpg"
    ]
  },
  {
    "genus": "Burmophora",
    "images": [
    ]
  },
  {
    "genus": "Calamiscus",
    "images": [
      "https://phorid.net/uploads_genera/Calamiscus-lateral.jpg"
    ]
  },
  {
    "genus": "Caledophora",
    "images": [
    ]
  },
  {
    "genus": "Cataclinusa",
    "images": [
      "https://phorid.net/uploads_genera/Cataclinusa-lateral.jpg"
    ]
  },
  {
    "genus": "Ceratoconus",
    "images": [
    ]
  },
  {
    "genus": "Ceratophoromyia",
    "images": [
    ]
  },
  {
    "genus": "Ceratoplatus",
    "images": [
    ]
  },
  {
    "genus": "Ceratusa",
    "images": [
      "https://phorid.net/uploads_genera/Ceratusa-lateral.jpg"
    ]
  },
  {
    "genus": "Ceylonoxenia",
    "images": [
    ]
  },
  {
    "genus": "Chaetaspidia",
    "images": [
      "https://phorid.net/uploads_genera/Chaetaspidia-lateral.jpg"
    ]
  },
  {
    "genus": "Chaetocnemistoptera",
    "images": [
      "https://phorid.net/uploads_genera/Chaetocnemistoptera-lateral.jpg"
    ]
  },
  {
    "genus": "Chaetogodavaria",
    "images": [
    ]
  },
  {
    "genus": "Chaetopleurophora",
    "images": [
    ]
  },
  {
    "genus": "Cheiloxenia",
    "images": [
    ]
  },
  {
    "genus": "Chelidophora",
    "images": [
    ]
  },
  {
    "genus": "Chonocephalus",
    "images": [
      "https://phorid.net/uploads_genera/Chonocephalus-lateral.jpg"
    ]
  },
  {
    "genus": "Clinochaeta",
    "images": [
    ]
  },
  {
    "genus": "Clitelloxenia",
    "images": [
    ]
  },
  {
    "genus": "Colobomeles",
    "images": [
    ]
  },
  {
    "genus": "Colyeria",
    "images": [
    ]
  },
  {
    "genus": "Commoptera",
    "images": [
      "https://phorid.net/uploads_genera/Commoptera-lateral.jpg"
    ]
  },
  {
    "genus": "Conicera",
    "images": [
      "https://phorid.net/uploads_genera/Conicera-lateral.jpg"
    ]
  },
  {
    "genus": "Coniceromyia",
    "images": [
      "https://phorid.net/uploads_genera/Coniceromyia-lateral.jpg"
    ]
  },
  {
    "genus": "Contopteryx",
    "images": [
    ]
  },
  {
    "genus": "Cootiphora",
    "tags": ["apterous", "brachypterous"],
    "images": [
      "https://phorid.net/uploads_genera/Cootiphora-lateral.jpg"
    ]
  },
  {
    "genus": "Corynusa",
    "images": [
    ]
  },
  {
    "genus": "Crasilla",
    "images": [
    ]
  },
  {
    "genus": "Cremersia",
    "images": [
      "https://phorid.net/uploads_genera/Cremersia-lateral.jpg"
    ]
  },
  {
    "genus": "Cryptophora",
    "tags": ["apterous"],
    "images": [
      "https://phorid.net/uploads_genera/Cryptophora-lateral.jpg"
    ]
  },
  {
    "genus": "Ctenopleuriphora",
    "images": [
    ]
  },
  {
    "genus": "Cyphocephalus",
    "images": [
      "https://phorid.net/uploads_genera/Cyphocephalus-lateral.jpg"
    ]
  },
  {
    "genus": "Cyphometopis",
    "images": [
    ]
  },
  {
    "genus": "Cyrtophorina",
    "images": [
    ]
  },
  {
    "genus": "Dacnophora",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Dacnophora-lateral.jpg"
    ]
  },
  {
    "genus": "Dahliphora",
    "images": [
      "https://phorid.net/uploads_genera/Dahliphora-lateral.jpg"
    ]
  },
  {
    "genus": "Danumphora",
    "images": [
      "https://phorid.net/uploads_genera/Danumphora-lateral.jpg"
    ]
  },
  {
    "genus": "Darwiniphora",
    "images": [
    ]
  },
  {
    "genus": "Diaclinella",
    "images": [
    ]
  },
  {
    "genus": "Dichocerina",
    "images": [
    ]
  },
  {
    "genus": "Dicranodeina",
    "images": [
    ]
  },
  {
    "genus": "Dicranopteron",
    "images": [
    ]
  },
  {
    "genus": "Dinocercus",
    "images": [
      "https://phorid.net/uploads_genera/Dinocercus-lateral.jpg"
    ]
  },
  {
    "genus": "Diocophora",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Diocophora-lateral.jpg"
    ]
  },
  {
    "genus": "Diplonevra",
    "images": [
      "https://phorid.net/uploads_genera/Diplonevra-lateral.jpg"
    ]
  },
  {
    "genus": "Diplostylocera",
    "images": [
    ]
  },
  {
    "genus": "Distichophora",
    "images": [
    ]
  },
  {
    "genus": "Dohrnigma",
    "images": [
    ]
  },
  {
    "genus": "Dohrniphora",
    "images": [
      "https://phorid.net/uploads_genera/Dohrniphora-lateral.jpg"
    ]
  },
  {
    "genus": "Dorsochaeta",
    "images": [
    ]
  },
  {
    "genus": "Dundophora",
    "images": [
    ]
  },
  {
    "genus": "Echidnophora",
    "images": [
    ]
  },
  {
    "genus": "",
    "images": [
    ]
  },
  {
    "genus": "",
    "images": [
    ]
  },
  {
    "genus": "Ecitomyia",
    "tags": ["brachypterous"],
    "images": [
      "https://phorid.net/uploads_genera/Ecitomyia-lateral.jpg"
    ]
  },
  {
    "genus": "Ecitophora",
    "tags": ["brachypterous"],
    "images": [
      "https://phorid.net/uploads_genera/Ecitophora-lateral.jpg"
    ]
  },
  {
    "genus": "Ecitoptera",
    "tags": ["brachypterous"],
    "images": [
      "https://phorid.net/uploads_genera/Ecitoptera-lateral.jpg"
    ]
  },
  {
    "genus": "Ecituncula",
    "tags": ["apterous"],
    "images": [
      "https://phorid.net/uploads_genera/Ecituncula-lateral.jpg"
    ]
  },
  {
    "genus": "Ectochaeta",
    "images": [
    ]
  },
  {
    "genus": "Egregiophora",
    "images": [
    ]
  },
  {
    "genus": "Eibesfeldtphora",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Eibesfeldtphora-lateral.jpg"
    ]
  },
  {
    "genus": "Enderleinphora",
    "images": [
      "https://phorid.net/uploads_genera/Enderleinphora-lateral.jpg"
    ]
  },
  {
    "genus": "Epacteon",
    "images": [
    ]
  },
  {
    "genus": "Epactoselia",
    "images": [
    ]
  },
  {
    "genus": "Epicnemis",
    "images": [
      "https://phorid.net/uploads_genera/Epicnemis-lateral.jpg"
    ]
  },
  {
    "genus": "Eremophora",
    "images": [
      "https://phorid.net/uploads_genera/Eremophora-lateral.jpg"
    ]
  },
  {
    "genus": "Erinacephora",
    "images": [
    ]
  },
  {
    "genus": "Eurycnemis",
    "images": [
      "https://phorid.net/uploads_genera/Eurycnemis-lateral.jpg"
    ]
  },
  {
    "genus": "Euryphora",
    "images": [
    ]
  },
  {
    "genus": "Euryplatea",
    "images": [
    ]
  },
  {
    "genus": "Eutermiphora",
    "images": [
    ]
  },
  {
    "genus": "Exochaeta",
    "images": [
    ]
  },
  {
    "genus": "Franssenia",
    "images": [
    ]
  },
  {
    "genus": "Godavaria",
    "images": [
    ]
  },
  {
    "genus": "Gymnophora",
    "images": [
      "https://phorid.net/uploads_genera/Gymnophora-lateral.jpg"
    ]
  },
  {
    "genus": "Gymnoptera",
    "images": [
    ]
  },
  {
    "genus": "Haplophleba",
    "images": [
    ]
  },
  {
    "genus": "Haulepta",
    "images": [
    ]
  },
  {
    "genus": "Hexacantherophora",
    "images": [
    ]
  },
  {
    "genus": "Hippaphora",
    "images": [
    ]
  },
  {
    "genus": "Hirotophora",
    "images": [
    ]
  },
  {
    "genus": "Holopterina",
    "images": [
      "https://phorid.net/uploads_genera/Holopterina-lateral.jpg"
    ]
  },
  {
    "genus": "Homalophora",
    "images": [
    ]
  },
  {
    "genus": "Horologiphora",
    "images": [
    ]
  },
  {
    "genus": "Hylophora",
    "images": [
    ]
  },
  {
    "genus": "Hypocera",
    "images": [
      "https://phorid.net/uploads_genera/Hypocera-lateral.jpg"
    ]
  },
  {
    "genus": "Hypocerides",
    "images": [
      "https://phorid.net/uploads_genera/Hypocerides-lateral.jpg"
    ]
  },
  {
    "genus": "Hypogeophora",
    "images": [
    ]
  },
  {
    "genus": "Idiophora",
    "images": [
    ]
  },
  {
    "genus": "Imparphora",
    "images": [
    ]
  },
  {
    "genus": "Iranphora",
    "images": [
    ]
  },
  {
    "genus": "Iridophora",
    "images": [
    ]
  },
  {
    "genus": "Javanoxenia",
    "images": [
    ]
  },
  {
    "genus": "Johowia",
    "images": [
      "https://phorid.net/uploads_genera/Johowia-lateral.jpg"
    ]
  },
  {
    "genus": "Kierania",
    "images": [
    ]
  },
  {
    "genus": "Kuenburgia",
    "images": [
    ]
  },
  {
    "genus": "Laciniomyia",
    "images": [
      "https://phorid.net/uploads_genera/Laciniomyia-lateral.jpg"
    ]
  },
  {
    "genus": "Laishania",
    "tags": ["apterous"],
    "images": [
      "https://phorid.net/uploads_genera/Laishania-lateral.jpg"
    ]
  },
  {
    "genus": "Laosphora",
    "images": [
    ]
  },
  {
    "genus": "Latiborophaga",
    "images": [
      "https://phorid.net/uploads_genera/Latiborophaga-lateral.jpg"
    ]
  },
  {
    "genus": "Lecanocerus",
    "images": [
      "https://phorid.net/uploads_genera/Lecanocerus-lateral.jpg"
    ]
  },
  {
    "genus": "Lenkoa",
    "images": [
    ]
  },
  {
    "genus": "Lepta",
    "images": [
    ]
  },
  {
    "genus": "Leptilla",
    "images": [
    ]
  },
  {
    "genus": "Linklloydia",
    "images": [
    ]
  },
  {
    "genus": "Lobochaeta",
    "images": [
      "https://phorid.net/uploads_genera/Lobochaeta-lateral.jpg"
    ]
  },
  {
    "genus": "Lucianaphora",
    "images": [
    ]
  },
  {
    "genus": "Macgrathphora",
    "images": [
      "https://phorid.net/uploads_genera/Macgrathphora-lateral.jpg"
    ]
  },
  {
    "genus": "Macrocerides",
    "images": [
      "https://phorid.net/uploads_genera/Macrocerides-lateral.jpg"
    ]
  },
  {
    "genus": "Macrocerophora",
    "images": [
    ]
  },
  {
    "genus": "Macroselia",
    "images": [
    ]
  },
  {
    "genus": "Maculiphora",
    "images": [
    ]
  },
  {
    "genus": "Mahabadphora",
    "images": [
    ]
  },
  {
    "genus": "Mallochphora",
    "images": [
    ]
  },
  {
    "genus": "Mannheimsia",
    "images": [
    ]
  },
  {
    "genus": "Megapropodiphora",
    "tags": ["brachypterous"],
    "images": [
      "https://phorid.net/uploads_genera/Megapropodiphora-lateral.jpg"
    ]
  },
  {
    "genus": "Megaselia",
    "images": [
      "https://phorid.net/uploads_genera/Megaselia-lateral.jpg"
    ]
  },
  {
    "genus": "Melaloncha",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Melaloncha-lateral.jpg"
    ]
  },
  {
    "genus": "Melittophora",
    "images": [
      "https://phorid.net/uploads_genera/Melittophora-lateral.jpg"
    ]
  },
  {
    "genus": "Menozziola",
    "images": [
      "https://phorid.net/uploads_genera/Menozziola-lateral.jpg"
    ]
  },
  {
    "genus": "Metopina",
    "images": [
      "https://phorid.net/uploads_genera/Metopina-lateral.jpg"
    ]
  },
  {
    "genus": "Metopina-gp",
    "images": [
    ]
  },
  {
    "genus": "Miclepta",
    "images": [
    ]
  },
  {
    "genus": "Microplatyphora",
    "images": [
    ]
  },
  {
    "genus": "Microselia",
    "images": [
    ]
  },
  {
    "genus": "Minicosta",
    "images": [
    ]
  },
  {
    "genus": "Misotermes",
    "images": [
    ]
  },
  {
    "genus": "Morahania",
    "images": [
    ]
  },
  {
    "genus": "Myopiomyia",
    "images": [
    ]
  },
  {
    "genus": "Myriophora",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Myriophora-lateral.jpg",
      "https://johnhash.me/images/M_pectinata_habitus.png",
      "https://johnhash.me/images/M_alexandrae_habitus.png"
    ]
  },
  {
    "genus": "Myrmomyia",
    "images": [
    ]
  },
  {
    "genus": "Myrmosicarius",
    "images": [
      "https://phorid.net/uploads_genera/Myrmosicarius-lateral.jpg"
    ]
  },
  {
    "genus": "Necperissa",
    "images": [
    ]
  },
  {
    "genus": "Neodohrniphora",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Neodohrniphora-lateral.jpg"
    ]
  },
  {
    "genus": "Neophora",
    "images": [
      "https://phorid.net/uploads_genera/Neophora-lateral.jpg"
    ]
  },
  {
    "genus": "Neopleurophora",
    "images": [
      "https://phorid.net/uploads_genera/Neopleurophora-lateral.jpg"
    ]
  },
  {
    "genus": "Obscurcaudaphora",
    "images": [
    ]
  },
  {
    "genus": "Obscuriphora",
    "images": [
    ]
  },
  {
    "genus": "Odontoxenia",
    "images": [
    ]
  },
  {
    "genus": "Oligophora",
    "images": [
    ]
  },
  {
    "genus": "Pachyneurella",
    "images": [
    ]
  },
  {
    "genus": "Palpiclavina",
    "images": [
    ]
  },
  {
    "genus": "Palpocrates",
    "images": [
    ]
  },
  {
    "genus": "Paraphiura",
    "images": [
    ]
  },
  {
    "genus": "Parasyneura",
    "images": [
    ]
  },
  {
    "genus": "Paratermitoxenia",
    "images": [
    ]
  },
  {
    "genus": "Paurophora",
    "tags": ["apterous"],
    "images": [
      "https://phorid.net/uploads_genera/Paurophora-lateral.jpg"
    ]
  },
  {
    "genus": "Pelidnophora",
    "images": [
    ]
  },
  {
    "genus": "Penthaplus",
    "images": [
    ]
  },
  {
    "genus": "Pericyclocerina",
    "images": [
    ]
  },
  {
    "genus": "Perissa",
    "images": [
    ]
  },
  {
    "genus": "Perittophora",
    "images": [
    ]
  },
  {
    "genus": "Peromitra",
    "images": [
    ]
  },
  {
    "genus": "Phalacrotophora",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Phalacrotophora-lateral.jpg"
    ]
  },
  {
    "genus": "Pheidolomyia",
    "images": [
    ]
  },
  {
    "genus": "Phlebothrix",
    "images": [
    ]
  },
  {
    "genus": "Phora",
    "images": [
      "https://phorid.net/uploads_genera/Phora-lateral.jpg"
    ]
  },
  {
    "genus": "Phymatopterella",
    "images": [
      "https://phorid.net/uploads_genera/Phymatopterella-lateral.jpg"
    ]
  },
  {
    "genus": "Physoptera",
    "images": [
    ]
  },
  {
    "genus": "Pilosaphiura",
    "images": [
    ]
  },
  {
    "genus": "Placophorina",
    "images": [
    ]
  },
  {
    "genus": "Plastophorides",
    "images": [
    ]
  },
  {
    "genus": "Platydipteron",
    "images": [
      "https://phorid.net/uploads_genera/Platydipteron-lateral.jpg"
    ]
  },
  {
    "genus": "Plectanocnema",
    "images": [
    ]
  },
  {
    "genus": "Plethysmochaeta",
    "images": [
    ]
  },
  {
    "genus": "Poloniphora",
    "images": [
    ]
  },
  {
    "genus": "Postoptica",
    "images": [
    ]
  },
  {
    "genus": "Pradea",
    "images": [
    ]
  },
  {
    "genus": "Procliniella",
    "images": [
    ]
  },
  {
    "genus": "Pronudiphora",
    "images": [
    ]
  },
  {
    "genus": "Pseudacteon",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Pseudacteon-lateral.jpg"
    ]
  },
  {
    "genus": "Pseudohypocera",
    "images": [
      "https://phorid.net/uploads_genera/Pseudohypocera-lateral.jpg"
    ]
  },
  {
    "genus": "Pseudoplastophora",
    "images": [
    ]
  },
  {
    "genus": "Pseudotermitoxenia",
    "images": [
    ]
  },
  {
    "genus": "Psyllomyia",
    "images": [
    ]
  },
  {
    "genus": "Ptochomyia",
    "images": [
    ]
  },
  {
    "genus": "Puliciphora",
    "tags": ["apterous"],
    "images": [
      "https://phorid.net/uploads_genera/Puliciphora-lateral.jpg"
    ]
  },
  {
    "genus": "Razorfemora",
    "images": [
    ]
  },
  {
    "genus": "Rhabdomyia",
    "images": [
    ]
  },
  {
    "genus": "Rhopica",
    "images": [
    ]
  },
  {
    "genus": "Rhynchomicropteron",
    "images": [
    ]
  },
  {
    "genus": "Rhyncophoromyia",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Rhyncophoromyia-lateral.jpg"
    ]
  },
  {
    "genus": "Ridiculiphora",
    "images": [
    ]
  },
  {
    "genus": "Ritchiephora",
    "images": [
    ]
  },
  {
    "genus": "Sacculiphora",
    "images": [
    ]
  },
  {
    "genus": "Sciadocera",
    "images": [
      "https://phorid.net/uploads_genera/Sciadocera-lateral.jpg"
    ]
  },
  {
    "genus": "Selenophora",
    "images": [
    ]
  },
  {
    "genus": "Septemineophora",
    "images": [
    ]
  },
  {
    "genus": "Siluphora",
    "images": [
    ]
  },
  {
    "genus": "Sinogodavaria",
    "images": [
    ]
  },
  {
    "genus": "Sorowoodiphora",
    "images": [
    ]
  },
  {
    "genus": "Sphinctomyia",
    "images": [
    ]
  },
  {
    "genus": "Spiniphora",
    "images": [
    ]
  },
  {
    "genus": "Stenodicrania",
    "images": [
    ]
  },
  {
    "genus": "Stenoneurellys",
    "images": [
    ]
  },
  {
    "genus": "Stenophorina",
    "images": [
    ]
  },
  {
    "genus": "Stethopathusa",
    "images": [
    ]
  },
  {
    "genus": "Stichillus",
    "images": [
      "https://phorid.net/uploads_genera/Stichillus-lateral.jpg"
    ]
  },
  {
    "genus": "Styletta",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Styletta-lateral.jpg"
    ]
  },
  {
    "genus": "Synclinusa",
    "tags": ["parasitoid"],
    "images": [
      "https://phorid.net/uploads_genera/Synclinusa-lateral.jpg"
    ]
  },
  {
    "genus": "Syneura",
    "images": [
      "https://phorid.net/uploads_genera/Syneura-lateral.jpg"
    ]
  },
  {
    "genus": "Syneurina",
    "images": [
    ]
  },
  {
    "genus": "Syntermitoxenia",
    "images": [
    ]
  },
  {
    "genus": "Syntermophora",
    "images": [
    ]
  },
  {
    "genus": "Tabelliphora",
    "images": [
      "https://phorid.net/uploads_genera/Tabelliphora-lateral.jpg"
    ]
  },
  {
    "genus": "Tapantia",
    "images": [
      "https://phorid.net/uploads_genera/Tapantia-lateral.jpg"
    ]
  },
  {
    "genus": "Tarsocrates",
    "images": [
    ]
  },
  {
    "genus": "Tayrona",
    "images": [
    ]
  },
  {
    "genus": "Tendcornphora",
    "images": [
    ]
  },
  {
    "genus": "Termitomyia",
    "images": [
    ]
  },
  {
    "genus": "Termitophilomyia",
    "images": [
    ]
  },
  {
    "genus": "Termitophorides",
    "images": [
    ]
  },
  {
    "genus": "Termitophorina",
    "images": [
    ]
  },
  {
    "genus": "Termitosagma",
    "images": [
    ]
  },
  {
    "genus": "Termitoscrofa",
    "images": [
    ]
  },
  {
    "genus": "Termitosphaera",
    "images": [
    ]
  },
  {
    "genus": "Termitostroma",
    "images": [
    ]
  },
  {
    "genus": "Termitoxenia",
    "images": [
    ]
  },
  {
    "genus": "Thalloptera",
    "images": [
      "https://phorid.net/uploads_genera/Thalloptera-lateral.jpg"
    ]
  },
  {
    "genus": "Thaumatoxena",
    "images": [
    ]
  },
  {
    "genus": "Tonnoirina",
    "images": [
    ]
  },
  {
    "genus": "Tranopeltoxenos",
    "tags": ["apterous"],
    "images": [
      "https://phorid.net/uploads_genera/Tranopeltoxenos-lateral.jpg"
    ]
  },
  {
    "genus": "Travassophora",
    "images": [
      "https://phorid.net/uploads_genera/Travassophora-lateral.jpg"
    ]
  },
  {
    "genus": "Trichocerina",
    "images": [
    ]
  },
  {
    "genus": "Trineurocephala",
    "images": [
      "https://phorid.net/uploads_genera/Trineurocephala-lateral.jpg"
    ]
  },
  {
    "genus": "Triphleba",
    "images": [
      "https://phorid.net/uploads_genera/Triphleba-lateral.jpg"
    ]
  },
  {
    "genus": "Trispiniphora",
    "images": [
    ]
  },
  {
    "genus": "Trophithauma",
    "images": [
      "https://phorid.net/uploads_genera/Trophithauma-lateral.jpg"
    ]
  },
  {
    "genus": "Trophodeinus",
    "images": [
      "https://phorid.net/uploads_genera/Trophodeinus-lateral.jpg"
    ]
  },
  {
    "genus": "Tropophleba",
    "images": [
    ]
  },
  {
    "genus": "Trucidophora",
    "images": [
    ]
  },
  {
    "genus": "Tubicera",
    "images": [
    ]
  },
  {
    "genus": "Tubiceroides",
    "images": [
    ]
  },
  {
    "genus": "Tubicerphora",
    "images": [
    ]
  },
  {
    "genus": "Veranophora",
    "images": [
    ]
  },
  {
    "genus": "Veruanus",
    "images": [
    ]
  },
  {
    "genus": "Vestigipoda",
    "tags": ["apterous"],
    "images": [
      "https://phorid.net/uploads_genera/Vestigipoda-lateral.jpg"
    ]
  },
  {
    "genus": "Volvectiphora",
    "images": [
    ]
  },
  {
    "genus": "Wandolleckia",
    "images": [
    ]
  },
  {
    "genus": "Wharia",
    "images": [
    ]
  },
  {
    "genus": "Woodiphora",
    "images": [
      "https://phorid.net/uploads_genera/Woodiphora-lateral.jpg"
    ]
  },
  {
    "genus": "Woodiphorides",
    "images": [
      
    ]
  }
]